import { render } from "./LocalSpinner.vue?vue&type=template&id=5a8716f4&scoped=true"
import script from "./LocalSpinner.vue?vue&type=script&lang=js"
export * from "./LocalSpinner.vue?vue&type=script&lang=js"

import "./LocalSpinner.vue?vue&type=style&index=0&id=5a8716f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8716f4"]])

export default __exports__